const AuthorizationStatus = {
    AUTHORIZED: 'AUTHORIZED',
    UNAUTHORIZED: 'UNAUTHORIZED',
}

export default AuthorizationStatus